
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import pc from './pc/administracion.vue';
    import movil from './pc/administracion.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: { pc, movil }
    } )
    export default class Componente extends Vue
    {



    }
